import { render, staticRenderFns } from "./Parent_Register_Component.vue?vue&type=template&id=e67f2c24&scoped=true"
import script from "./Parent_Register_Component.vue?vue&type=script&lang=js"
export * from "./Parent_Register_Component.vue?vue&type=script&lang=js"
import style1 from "./Parent_Register_Component.vue?vue&type=style&index=1&id=e67f2c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67f2c24",
  null
  
)

export default component.exports